
import { DossierConfigService } from "@/services/dossier-config-service";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";

export default FormLike.extend({
	data(){
		return {
			name: "",
			website: "",
			email: "",
			phone: ""
		};
	},
	methods: {
		cancel(){
			this.$emit("cancel");
		},
		async submit(){
			if (!this.isValid) return;
			let result = await DossierConfigService.createMollieProfgile(this.name, this.website, this.email, this.phone);
			this.$emit("input", result);
		}
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	},
});
